import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;

  .edital-toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 10px 16px;
    border-bottom: 1px solid #dee2e6;
    background: #fff;
    color: #495057;

    select {
      max-width: 60%;
    }

    .btn {
      display: inline-flex;
      align-items: center;
      gap: 6px;
      flex-shrink: 0;

      .material-icons-outlined {
        font-size: 18px;
      }
    }
  }

  .edital-file-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .edital-preview {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    background: #e9ecef;
    padding: 16px;

    .file-preview-frame {
      border: 0;
      border-radius: 0;
      background: #fff;
      box-shadow: 0 1px 4px rgba(0, 0, 0, 0.15);
    }
  }
`;
